export function convertObjectToArray(obj) {
  if (!obj) return []
  return Object.keys(obj).map(key => ({key: key, value: obj[key]}))
}

export function convertArrayToObject(arr, convertToFloat = false) {
  return arr.reduce((m, v) => {
    if (v.key && v.key !== '' && v.value && v.value !== '') {
      m[v.key] = convertToFloat ? parseFloat(v.value) || v.value : v.value
      return m
    } else {
      return {}
    }
  }, {})
}

export function handleChangeDynamicInput(stateKey) {
  return function (event, idx, valueType = null) {
    let newValue = this.state[stateKey]
    newValue[idx][event.target.name] = (valueType === 'number' ? Number(event.target.value) : event.target.value)
    this.setState({[stateKey]: newValue})
  }
}

export function handleDeleteDynamicInput(stateKey) {
  return function (idx) {
    let newValue = this.state[stateKey]
    this.setState({[stateKey]: newValue.filter((s, sidx) => idx !== sidx)})
  }
}

export function handleAddDynamicInput(stateKey) {
  return function () {
    let newValue = this.state[stateKey].length > 0 ? this.state[stateKey] : []
    newValue.push({key: '', value: ''})
    this.setState({[stateKey]: newValue})
  }
}



// WEBPACK FOOTER //
// ./src/components/Support/dynamicInputs/helpers.js